<template>
  <div class="zyzbody">
    <div class="form-check text-center">
      <input class="form-check-input" type="checkbox" v-model="useurl" id="imgmode" />
      <label class="form-check-label" for="imgmode">图片使用外链</label>
    </div>
    <div class="container list">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-12 card"
          v-for="(doc,index) in docs"
          :key="doc.title"
        >
          <h4>{{index+1}}</h4>
          <!-- <img class="img-fluid" :src="imgUrl+doc.title" /> -->
          <!-- <img style="width:100%" :src="imgUrl+doc.title.replace(/\+/,'%2B').replace(/\//g,'%2F').replace(/\?/,'%3F')+'?token='+token" /> -->
          <img v-if="useurl" style="width:100%" :src="doc.imgurl" />
          <img v-else style="width:100%" :src="imgUrl+urlencode(doc.title)+'?token='+token" />
          <div>【标题】：{{doc.title}}</div>
          <div>【分类】：{{doc.category}}</div>
          <div>【时间】：{{doc.updatetime}}</div>
          <div class="cut">
            【xflink】：
            <ul>
              <li v-for="(link,indexL) in doc.xfurl" :key="link">
                <a :href="link" target="_blank">{{indexL+1}}.{{link}}</a>
              </li>
            </ul>
          </div>
          <div>
            <button class="btn btn-block" :class="{'btn-primary':!favorited(doc)}" @click="handleFavorite(doc)">
              <span v-if="favorited(doc)">取消收藏</span>
              <span v-else>收藏</span>
            </button>
          </div>
          <div style="overflow:scroll;height:200px">
            【简介】：
            <span v-html="doc.intro.replace(/<img/g,'<img class=img-fluid')"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import urlencode from "urlencode"
export default {
  name:'Zyzbody',
  props: ['docs','imgUrl','token','favorites'],
  methods:{
    urlencode:urlencode,
    handleFavorite:function(doc){
      this.$emit("favorite",doc)
    },
    favorited(doc){
      return this.favorites.some(f => {
        return f.title==doc.title;
      });
    }
  },
  data(){
    return {
      useurl:false
    }
  }
};
</script>
<style scoped>
div.cut {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>